import React from 'react';

const FeatureTitle = (props) => {
  const { children } = props;

  return <h3 className="product-tour__subtitle">{children}</h3>;
};

export default FeatureTitle;
